<span class="truncated-content" fxFlex="0 1 auto" [matTooltip]="tooltip || text"
  [matTooltipDisabled]="disabled || (shouldDisableTooltip | async)" [matTooltipPosition]="position">
  <ng-content></ng-content>
  {{ text || '' }}
</span>

<span class="truncate-check" #showTooltip></span>

<ng-content select="[suffix]"></ng-content>
